export default {
    webhooksList: function (state) {
        return state.webhooksList
    },
    webhooksFields: function (state) {
        return state.webhooksFields
    },
}
